interface ApiConfig {
  key: string
  dev?: boolean
  version?: string
  appId?: string
}

export default class Api {
  static baas = ['_id', 'createdAt', 'updatedAt']

  static filterBaaSKeywords (params: any) {
    if (!params) return params
    for (let keyword of Api.baas) params[keyword] = undefined
    return params
  }

  private _key: string
  private _plugins: Array<Function>

  constructor (private _config: ApiConfig) {
    this._key = _config.key
    this._plugins = []
  }

  handleBaaSPayload (data: any): string {
    const { _plugins: plugins, _key: key } = this
    const body = Object.assign({}, Api.filterBaaSKeywords(data), { key })
    for (let plugin of plugins) { Object.assign(body, plugin(body) || {}) }
    return JSON.stringify(body)
  }

  mosaicRequestURL (tableName: string): string {
    const { dev = false } = this._config
    const url = dev ? 'ssr.alpha.elenet.me/shap-api' : 'ssr.ele.me/shap-api'
    return `https://${url}/${tableName}`
  }

  request (method: string = 'post', tableName: string, data: object = {}): Promise<any> {
    const mosaicRequestURL = this.mosaicRequestURL.bind(this, tableName)
    const lowerCaseMethodName = method.toLowerCase()

    const url = lowerCaseMethodName === 'get'
      ? mosaicRequestURL(undefined, data)
      : mosaicRequestURL()

    return fetch(url, {
      headers: new Headers({ 'content-type': 'application/json' }),
      method: lowerCaseMethodName.toUpperCase(),
      body: lowerCaseMethodName === 'get' ? null : this.handleBaaSPayload(data)
    }).then(response => response.json())
  }

  plugin (cb: Function) {
    this._plugins.push(cb)
  }
}

['patch', 'post', 'get', 'delete'].forEach(method => {
  Api.prototype[method] = function (...args: any[]) { return this.request(method, ...args) }
})
